// extracted by mini-css-extract-plugin
export default {"container":"Jarvis_container__6LW03"};